export default __webpack_public_path__ + "static/media/quickswap.7eb85178.png";